// react components
import React from 'react'

// data
import {
    reduxModalStateSite,
} from 'data'

// serializers
import {
    CustomCSSProperties,
    FormFieldCustomSerializer,
    formInfoTypeSite,
} from 'serializers/site'

// services
import {
    getStylesNew,
} from 'services'

// props
type TemplateBlock797RadioSiteProps = {
    blockId: string
    deviceType: 'is-mobile' | 'is-tablet' | 'is-web'
    formInfo: formInfoTypeSite
    formInputObj: FormFieldCustomSerializer | undefined
    handleInputChange: (name: string, value: any, label: string, stripe_field_type: string | undefined, stringValue?: string) => void
    isEditHovered: boolean
    learnItem?: any
    reduxModalSite: reduxModalStateSite
    stylesNew: CustomCSSProperties | undefined
    tabIndex: number
}

// main
export const TemplateBlock797RadioSite: React.FC<TemplateBlock797RadioSiteProps> = React.memo(({
    blockId,
    deviceType,
    formInfo,
    formInputObj,
    handleInputChange,
    isEditHovered,
    learnItem,
    reduxModalSite,
    stylesNew,
    tabIndex,
}) => {

    let is_correct = false
    let submitted_value = ''
    if (learnItem?.form_values?.[formInputObj?.id!]) {
        is_correct = learnItem?.form_values?.[formInputObj?.id!].is_correct
        submitted_value = learnItem?.form_values?.[formInputObj?.id!].submitted_value
    }

    return (
        <div
            id={blockId}
            className={`template-block-797 radio${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}${learnItem?.is_form_completed ? ' disabled' : ''}`}
        >
            {formInputObj?.options?.map((val) => (
                <div
                    key={val.id}
                    className='t-797-radio-input-div'
                    style={formInputObj.styles_797 ? getStylesNew(reduxModalSite, formInputObj.styles_797, undefined) : stylesNew}
                >
                    <input
                        checked={learnItem?.is_form_completed ? submitted_value === val.id : undefined}
                        name={formInputObj?.name}
                        onChange={(e) => handleInputChange(formInputObj?.name!, e.target.value, formInputObj?.label!, formInputObj?.stripe_field_type, (formInfo?.form_is_external || formInfo?.form_is_subscription || (formInfo?.formSubmitType && !['miscellanea_contact', 'miscellanea_mail'].includes(formInfo?.formSubmitType))) ? val.id : val.value)}
                        // tabIndex={tabIndex}
                        type='radio'
                        value={(formInfo?.form_is_external || formInfo?.form_is_subscription || (formInfo?.formSubmitType && !['miscellanea_contact', 'miscellanea_mail'].includes(formInfo?.formSubmitType))) ? val.id : val.value}
                    />
                    <span className='t-797-radio-label'>{val.value}</span>
                </div>
            ))}
            {learnItem?.is_form_completed && (
                <span className={`t-797-correct-answer ${is_correct ? 'is-correct' : 'is-incorrect'}`}>
                    <i className={is_correct ? 'mo-new-icon-check-circle-regular' : 'mo-new-icon-circle-xmark-regular'} />
                    <span className='t-797-correct-answer-text'>{is_correct ? 'Correct' : 'Incorrect'}</span>
                </span>
            )}
        </div>
    )
})
